const styles = ({ COLORS }) => ({
  container: {
    maxWidth: '50%',
    textAlign: 'center',
    fontSize: '16px',
    margin: '20px auto 40px',
    lineHeight: '24px'
  },
  link: {
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none'
  },
  illustration: {
    margin: '20px auto',
    display: 'block',
    maxWidth: '200px'
  },
  filter: {
    maxWidth: '300px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '30px'
  },
  label: {
    margin: '0 10px 0 0'
  },
  intro: {
    border: '1px solid #e5e5e5',
    borderRadius: '4px',
    padding: '10px 20px',
    color: '#777',
    '& h5': {
      margin: '12px 0'
    }
  }
})

export default styles
